import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LuAlertTriangle } from 'react-icons/lu';

// COMPONENTS
import Icon from 'components/Atoms/Icons/Icon';

// DS
import { Col, Row, VertButton, VertModal, VertTypography } from '@vertem-core/vertice-ds';

// UTILS
import ynToBool from 'Utils/ynToBool';

const checkSubMessage = (error) => error === '#DoNotShowDescription' ? '' : error;

const createULFromSubs = (subs, subMessage) => {
  if (!subs || !Array.isArray(subs)) {
    return ''
  }

  return (
    <ul>
      {subMessage && (
        <SubMessageWrapper>
          {subMessage}
        </SubMessageWrapper>
      )}
      {subs.map((sub, index) => {
        // Type: 290 is sku unavailable
        if (sub && typeof sub === 'object' && sub.message && sub.type !== 290) {
          return (
            <SubMessageWrapper key={index}>
              {sub.message}
            </SubMessageWrapper>
          )
        }
        return null
      })}
    </ul>
  )
};

const SubMessageWrapper = ({ children }) => {
  return (
    <Row className='margin-bottom-extra-small '>
      <Col className='col-12'>
        <VertTypography.Text className='txt-paragraph color-neutral-dark font-w-400'>
          { children }
        </VertTypography.Text>
      </Col>
    </Row>
  )
};
 
// CART ALERT COMPONENT
const ModalErrorAlert = ({ className, error, hasError, actionHandler=() => {} }) => {

 
  /* States */
  const [isOpen, setIsOpen] = useState(ynToBool(hasError));

  /* Vars */
  const message = error?.message || 'Não foi possível concluir.'
  const subMessage = checkSubMessage(error?.subMessage) === '' ? `` : (error?.subMessage || 'Por favor tente novamente em instantes');
  const complementMessagens = createULFromSubs(error?.subs, subMessage)

  /* Handlers */
  const cancelHandler = () => {
    setIsOpen(false);

    actionHandler && actionHandler();
  };

  /* Renders */
  return (
    <VertModal
      open={isOpen}
      onCancel={cancelHandler}
      className={`cart-alert-modal  ${className}`}
      spacing="big"
    >
      <Row>
        <Col className='col-12 margin-bottom-regular' align={'center'}>
          <Icon className="lucide color-neutral-dark-darker" size="40px" component={LuAlertTriangle} />
        </Col>
        <Col className='col-12 margin-bottom-regular' align={'center'}>
          <VertTypography.Title className='margin-bottom-small txt-big color-neutral-dark-darker font-w-600'>
            { message }
          </VertTypography.Title>
          { complementMessagens || subMessage }
        </Col>
        <Col className='col-12' align={'center'}>
          <VertButton type='detached' onClick={cancelHandler}>Entendi</VertButton>
        </Col>
      </Row>
    </VertModal>
  );
};
ModalErrorAlert.propTypes = {
  className: PropTypes.string,
  error: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  actionHandler: PropTypes.func,
};

export default ModalErrorAlert;
